<h2 mat-dialog-title class="mat-title">
  <span >{{data.title| translate}}</span>
  <span class="close-dialog" (click)="close()">&#10006;</span>
</h2>
<mat-dialog-content>
  <div class="search-container" *amIfTablet>
    <div class="search">
      <form>
        <mat-form-field floatLabel="always" appearance="outline" >
            <mat-label class="mat-label">{{ "SEARCH.search" | translate }}</mat-label>
            <input id="search" #search matInput
                (keyup)="monitorSearch(search.value)" [placeholder]="'COMPANY_BRANCHES.searchPlaceholder' | translate" />
            <button type="button" mat-icon-button matSuffix (click)="monitorSearch(search.value)">
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>
      </form>
    </div>
</div>

  <div *amIfTablet>
    <table mat-table [dataSource]="dataSource" *amIfTablet matSort>
      <!-- Checkbox Column -->
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="selected-label">
          <mat-checkbox
                color="primary" 
                #ref (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="isPartiallySelected()"
              >
              </mat-checkbox>
        </th>
        <td mat-header-cell class="border" *matCellDef="let row">
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)" 
          >
          </mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header width="40%"> {{ 'COMPANY_BRANCHES.name' | translate }} </th>
        <td mat-cell *matCellDef="let branch"> {{branch.name}}  @if (!branch.parentAccountId) {
<mat-chip>{{'COMPANY_BRANCHES.headQuarters' | translate}}</mat-chip>
}</td>
      </ng-container>
      <ng-container matColumnDef="sectorNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'COMPANY_BRANCHES.sectorNumber' | translate }} </th>
        <td mat-cell *matCellDef="let branch"> {{branch.sectorNumber}} </td>
      </ng-container>
    
    
      <ng-container matColumnDef="location">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'COMPANY_BRANCHES.location' | translate }} </th>
        <td mat-cell *matCellDef="let branch"> {{branch.location}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
    </table>
    @if (branchesCount > 5) {
    <mat-paginator #paginator [showFirstLastButtons]="true" [length]="branchesCount" [pageSize]="5"></mat-paginator>
    }
  </div>

  <div class="search-container-mobile" *amIfMobile>
    <div class="search">
      <form>
        <mat-form-field floatLabel="always" appearance="outline" >
            <mat-label class="mat-label">{{ "SEARCH.search" | translate }}</mat-label>
            <input id="search" #search matInput
                (keyup)="monitorSearch(search.value)" [placeholder]="'COMPANY_BRANCHES.searchPlaceholder' | translate" />
            <button type="button" mat-icon-button matSuffix (click)="monitorSearch(search.value)">
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>
      </form>
    </div>
</div>

  <div class="mobile-table" *amIfMobile>
    <table mat-table [dataSource]="dataSource" *amIfMobile>
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="selected-label">
        </th>
        <td width="10%" mat-header-cell class="border" *matCellDef="let row">
          <mat-checkbox
            color="primary"
            (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)" 
          >
          </mat-checkbox>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef></th>
        <td width="90%" mat-cell class="name" *matCellDef="let branch">
          <div class="content">
            <div class="chip"> 
              {{branch.name}} 
              <span>{{ branch.city }}, {{ branch.state }}</span>

            </div>
            @if (!branch.parentAccountId) {
            <mat-chip>{{'COMPANY_BRANCHES.headQuarters' | translate}}</mat-chip>
            }
          </div> 
        </td>
      </ng-container>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsMobile;" class="table-row"></tr>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" mat-dialog-close>{{"COMPANY_ADD_USERS.cancel" | translate}}</button>
  <button mat-raised-button color="primary" (click)="selectedBranches()" [mat-dialog-close]="true" [disabled]="selection.isEmpty()">{{"COMPANY_ADD_USERS.okay" | translate}}</button>
</mat-dialog-actions>
